import { render, staticRenderFns } from "./data_sets.vue?vue&type=template&id=825f58f8&scoped=true"
import script from "./data_sets.vue?vue&type=script&lang=js"
export * from "./data_sets.vue?vue&type=script&lang=js"
import style0 from "./data_sets.vue?vue&type=style&index=0&id=825f58f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825f58f8",
  null
  
)

export default component.exports